import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import { Dialog } from "primereact/dialog";
import { Button } from "../../../../components/ui/Button";
import { Message } from 'primereact/message';

import UploadMedia from "./UploadMedia";
import Link from "./Link";

import { useGalleryContext } from "../../../Contexts/GalleryContext";
import { useCheckMediaCapacity } from "../../../../queries";
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { ProgressSpinner } from 'primereact/progressspinner';

function UploadPopup({ currentFolder, content = "media" }) {
  const { t } = useTranslation();
  const { capacityAvailability } = useGalleryContext();
  const { isLoading } = useCheckMediaCapacity();
  const openDialog = useSelector((state) => state.global.openDialog);
  const dispatch = useDispatch();
  let isCampaignUpload = openDialog.addContent

  const onClose = () => {
    dispatch(toggleDialog("uploadMedia"))
  }

  return (
    <>
      <div className="flex justify-end items-center">
        {/* md+ full button */}
        <Button
          label={content === "media" ? t('buttons.upload') : t('media.media_new_link')}
          icon={content === "media" ? "fas fa-upload" : "fas fa-plus"}
          className="p-button-sm px-5 hidden md:inline-flex"
          onClick={() => dispatch(toggleDialog("uploadMedia"))}
        />
        {/* < md icon-only */}
        <Button
          icon={content === "media" ? "fas fa-upload" : "fas fa-plus"}
          className="p-button-sm md:hidden"
          onClick={() => dispatch(toggleDialog("uploadMedia"))}
        />
      </div>

      <Dialog
        header={content == "media" ? t('media.media_upload_title') : t('media.media_link_upload_title')}
        visible={openDialog.uploadMedia}
        onHide={onClose}
        breakpoints={{ "960px": "95vw" }}
        className="pp-upload-dialog"
        style={{
          width:
            // isCampaignUpload ? "60vw" :
            content == "media" ? "55vw" : "40vw"
        }}
      >
        {
          isLoading ?
            <div className="w-full h-[300px] flex items-center justify-content">
              <ProgressSpinner
                className='h-[75px] w-[75px] flex justify-center items-center'
                strokeWidth="2"
                fill="var(--surface-ground)"
                animationDuration="30s" />
            </div>
            :
            capacityAvailability <= 0 && content === "media" ?
              <div className="p-5 text-center ">
                <Message className="fw-bold fs-3 p-4 w-100" severity="warn" text={t('media.media_storage_limit_reached')} />
              </div>
              :
              content == "media" ?
                <UploadMedia onClose={onClose} currentFolder={currentFolder} capacityAvailability={capacityAvailability} disabled={capacityAvailability <= 0} />
                :
                <Link />
        }
      </Dialog>
    </>
  );
}

export default UploadPopup;